import s from './style.module.scss';

import { Display } from '@/components/Display/Display';
import Mask from '../../../components/Mask';
import cryImg from '@/assets/images/simulation/cry.gif';

import cheerImg from '@/assets/images/simulation/cheer.gif';
import FireWork from '../../../components/FireWork';
import { useRef } from 'react';
import { feedBackTypeMap } from '@/utils/contants/caseSimulation';
import EnterImg from '@/components/CaseProgressCircle/EnterImg';
const FeedBackModal = (props) => {
    const feedbackData = props.resultData;
    const fireWorkRef = useRef(null);
    const { onNext, onReChose, show } = props;

    return (
        <>
            {/* '🥹'🐷 */}
            <Mask show={show} text={feedbackData.is_correct ? '🎉' : '🥹'}>
                <div className={s['feedback-modal-box']}>
                    <div className={s['feedback-modal-content-box']}>
                        <Display show={!feedbackData.is_correct}>
                            <div className={s['feedback-modal-img']}>
                                <img className={s['error']} src={cryImg} alt="" />
                            </div>
                        </Display>
                        <Display show={feedbackData.is_correct}>
                            <div className={s['feedback-modal-img']}>
                                <img className={s['cheer']} src={cheerImg} alt="" />
                                <div className={s['ribbon']}>
                                    <FireWork ref={fireWorkRef}></FireWork>
                                </div>
                                {/* <img className={s['ribbon']} src={ribbonImg} alt="" /> */}
                            </div>
                            {/* <Arrow onClick={onNext} className={s['arrow']} /> */}
                        </Display>
                        {/* <Display show={!feedbackData.is_correct && feedbackData?.feedback_mode !== feedBackTypeMap.instantBackAndCorrect}>
                            <Arrow onClick={onNext} className={s['arrow']} />
                        </Display> */}

                        <div className={s['feedback-modal-content']}>{feedbackData.feedback_text}</div>
                    </div>
                    <Display show={feedbackData.is_correct}>
                        <div className={s['arrow-wrap']}>
                            <EnterImg onclickArrow={onNext} color="white" />
                        </div>
                    </Display>
                    <Display show={!feedbackData.is_correct && feedbackData?.feedback_mode === feedBackTypeMap.instantBackAndCorrect}>
                        <div className={s['feedback-modal-button']} onClick={onReChose}>
                            重新选择
                        </div>
                    </Display>
                    <Display show={!feedbackData.is_correct && feedbackData?.feedback_mode !== feedBackTypeMap.instantBackAndCorrect}>
                        <div className={s['arrow-wrap']}>
                            <EnterImg color="white" onclickArrow={onNext} />
                        </div>
                    </Display>
                </div>
            </Mask>
        </>
    );
};

export default FeedBackModal;
